import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from '../Images/SMT.png';

const Header = () => {
  const [activeLink, setActiveLink] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const scrollToHome = () => {
      const homeSection = document.getElementById("Home");
      if (homeSection) {
        homeSection.scrollIntoView({ behavior: "smooth" });
      }
    };

    scrollToHome();

    const handleScroll = () => {
      const sections = document.querySelectorAll("section[id]");
      const scrollY = window.scrollY;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        if (
          scrollY >= sectionTop - 50 &&
          scrollY <= sectionTop + sectionHeight - 50
        ) {
          setActiveLink(section.id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavigateToHome = () => {
    navigate("/");
    setTimeout(() => {
      const homeSection = document.getElementById("Home");
      if (homeSection) {
        homeSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 0); // Allow React Router to complete navigation before scrolling
  };

  return (
    <nav className="navbar navbar-expand-sm bg-light fixed-top">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/" onClick={handleNavigateToHome} style={{ cursor: "pointer" }}>
            <img src={logo} alt="Logo" style={{ width: "80px", height: "25px" }} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarCollapse"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarCollapse">
          <ul className="navbar-nav ms-auto mb-2 mb-md-0">
            <li className="nav-item">
              <Link
                className={`nav-link2 ${
                  activeLink === "Home" ? "active" : ""
                }`}
                to="/#Home"
                onClick={() => handleClick("Home")}
              >
                <b>Home</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link2 ${
                  activeLink === "Services" ? "active" : ""
                }`}
                to="/#Services"
                onClick={() => handleClick("Services")}
              >
                <b>Services</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link2 ${
                  activeLink === "Packages" ? "active" : ""
                }`}
                to="/#Packages"
                onClick={() => handleClick("Packages")}
              >
                <b>Packages</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link2 ${
                  activeLink === "ServiceCountries" ? "active" : ""
                }`}
                to="/#ServiceCountries"
                onClick={() => handleClick("ServiceCountries")}
              >
                <b>Service Countries</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link2 ${
                  activeLink === "AssociatedPartners" ? "active" : ""
                }`}
                to="/#AssociatedPartners"
                onClick={() => handleClick("AssociatedPartners")}
              >
                <b>Associated Partners</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link2 ${
                  activeLink === "Contact" ? "active" : ""
                }`}
                to="/#Contact"
                onClick={() => handleClick("Contact")}
              >
                <b>Contact</b>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className={`nav-link2 ${
                  activeLink === "About" ? "active" : ""
                }`}
                to="/#About"
                onClick={() => handleClick("About")}
              >
                <b>About</b>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
